/**
 * Where a hike's route cards can be edited, as the print page shows it under
 * the route cards switch: the hike's own address with /route-cards on the
 * end ("Cards can be edited at hiiker.app/hikes/ireland/dublin/wicklow-way/route-cards").
 *
 * The page is RouteCardsController#official_hike / #user_hike, which opens the
 * editor on the hike's first day. Twins: `RouteCardsLink.swift` (iOS) and
 * `RouteCardsLink.kt` (Android) build the same URL from the hike's
 * `shareableUrl`, so all three print pages print the same link.
 */

/** Cards belong to a hike's days, so only a hike print offers them. */
export function showsRouteCards(sourceType: string | null | undefined): boolean {
  return sourceType === 'Hike';
}

/**
 * The hike's page URL with /route-cards appended — any query or fragment on
 * it dropped, so a shared link's tracking tail cannot end up in the middle.
 * Null without a hike URL to build on.
 */
export function routeCardsEditUrl(hikeUrl: string | null | undefined): string | null {
  const base = (hikeUrl ?? '').trim().replace(/[?#].*$/, '').replace(/\/+$/, '');
  return base ? `${base}/route-cards` : null;
}

/** The link as it reads in the sentence: no scheme, nothing to trip over. */
export function routeCardsDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '');
}
